import usePrivateAxios from '@/common/api/usePrivateAxios'
import { INTEGRATION_PROVIDER } from '@/features/modelIntegrationCodes/constants/providers.constant'
import { IntegrationCodeMatch } from '@/features/modelIntegrationCodes/types/suggestedModel.type'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

interface UseBestIntegrationCodesProps {
  modelIntegrationCodeId?: string
  equipmentId?: string
  enabled?: boolean
}

export const useBestIntegrationCodes = ({
  modelIntegrationCodeId,
  equipmentId,
  enabled = true,
}: UseBestIntegrationCodesProps) => {
  const privateAxios = usePrivateAxios()

  const { data = [], ...rest } = useQuery({
    queryKey: ['modelIntegrationCodes', 'bestMatches', modelIntegrationCodeId, equipmentId],
    enabled: enabled && !!modelIntegrationCodeId && !!equipmentId,
    queryFn: () =>
      privateAxios.get(`/equipment_models/${modelIntegrationCodeId}/find_best_integration_codes_matches`, {
        params: { provider: INTEGRATION_PROVIDER, equipment_id: equipmentId },
      }),
    select: (response: { data: { data: IntegrationCodeMatch[] } }) => response?.data?.data ?? [],
    placeholderData: keepPreviousData,
  })

  return { data, ...rest }
}
